export default "__VITE_ASSET__rXGjc$cC__"